module.exports = __webpack_public_path__ + "static/media/il.f1cb7c21.svg";


//////////////////
// WEBPACK FOOTER
// ./src/images/countriesFlags/il.svg
// module id = 1452
// module chunks = 0